import {BreadcrumbArrow} from '../../../icons'
import styles from './index.module.scss'
import {Link} from 'react-router-dom'
import {useContext} from 'react'
import { PageContext } from '../../../context/PageContextProvider';

const Breadcrumb = ({crumbs}) => {
   const { language } = useContext(PageContext);
   return(
      <div className={styles['breadcrumb-container']}>
          {crumbs.map((crumb,i) =>(
            i===0?
            <Link to={crumb.link}>{crumb.text[language]}</Link>
            :
            <div>
               <BreadcrumbArrow /> 
               <Link to={crumb.link}>{crumb.text[language]}</Link>
            </div>
          ))}
      </div>
   )
}

export default Breadcrumb;